(() => {
  const STYLE_ID = 'lcpp-complete-set-styles-v2';
  const BODY_IN_VIEW = 'lcpp-complete-set-in-view';
  const MAX_ITEMS = 2;

  const getRoot = () => {
    let root = window.Shopify?.routes?.root || '/';
    if (!root.endsWith('/')) root += '/';
    return root;
  };

  const getHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  };

  const toCents = (price) => {
    const value = Number(price) || 0;
    return typeof price === 'string' ? Math.round(value * 100) : Math.round(value);
  };

  const formatMoney = (price) => {
    const value = toCents(price) / 100;
    try {
      const locale = (document.documentElement.lang || 'nl-NL').replace('_', '-');
      const currency = window.Shopify?.currency?.active || 'EUR';
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value);
    } catch (_) {
      return `€ ${value.toFixed(2).replace('.', ',')}`;
    }
  };

  const addStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .lcpp-complete-set{margin:18px 0 6px;padding:18px;border:1px solid #d7e2ea;border-radius:18px;background:linear-gradient(180deg,#fff 0%,#f7fafc 100%);box-shadow:0 8px 28px rgba(11,35,57,.07)}
      .lcpp-complete-set__head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:12px}
      .lcpp-complete-set__eyebrow{display:inline-flex;align-items:center;gap:6px;margin:0 0 5px;color:#176447;font-size:11px;line-height:1;font-weight:900;letter-spacing:.08em;text-transform:uppercase}
      .lcpp-complete-set__eyebrow::before{content:'✓';display:grid;place-items:center;width:18px;height:18px;border-radius:999px;background:#e5f5ed;color:#176447;font-size:11px}
      .lcpp-complete-set__title{margin:0;color:#0b2339;font-size:19px;line-height:1.2;font-weight:850;letter-spacing:-.015em}
      .lcpp-complete-set__subtitle{margin:5px 0 0;color:#617181;font-size:13px;line-height:1.45}
      .lcpp-complete-set__items{display:grid;gap:10px}
      .lcpp-complete-set__item{display:grid;grid-template-columns:auto 72px minmax(0,1fr);align-items:center;gap:12px;padding:11px;border:1px solid #e4ebf0;border-radius:14px;background:#fff;transition:border-color .16s ease,box-shadow .16s ease,opacity .16s ease}
      .lcpp-complete-set__item:has(.lcpp-complete-set__check:checked){border-color:#b9d8cb;box-shadow:0 3px 12px rgba(20,96,68,.06)}
      .lcpp-complete-set__item:has(.lcpp-complete-set__check:not(:checked)){opacity:.68}
      .lcpp-complete-set__check{width:20px;height:20px;margin:0;accent-color:#176447;cursor:pointer}
      .lcpp-complete-set__image-link{display:block;width:72px;height:72px;border-radius:12px;overflow:hidden;background:#fff;border:1px solid #e4ebf0}
      .lcpp-complete-set__image{display:block;width:100%;height:100%;object-fit:contain}
      .lcpp-complete-set__info{min-width:0}
      .lcpp-complete-set__name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;color:#102a3f;text-decoration:none;font-size:14px;line-height:1.35;font-weight:800}
      .lcpp-complete-set__name:hover{text-decoration:underline}
      .lcpp-complete-set__meta{display:flex;flex-wrap:wrap;align-items:center;gap:7px;margin-top:5px}
      .lcpp-complete-set__price{color:#0b2339;font-size:14px;line-height:1.2;font-weight:850}
      .lcpp-complete-set__stock{display:inline-flex;align-items:center;gap:5px;color:#176447;font-size:11px;font-weight:750}
      .lcpp-complete-set__stock::before{content:'';width:7px;height:7px;border-radius:999px;background:#2a9b6d}
      .lcpp-complete-set__variant{display:block;width:100%;max-width:260px;margin-top:8px;min-height:38px;padding:7px 32px 7px 10px;border:1px solid #d9e3e9;border-radius:9px;background:#fff;color:#173047;font:inherit;font-size:12px}
      .lcpp-complete-set__foot{margin-top:13px;padding-top:13px;border-top:1px solid #e2e9ee}
      .lcpp-complete-set__summary{display:flex;align-items:flex-end;justify-content:space-between;gap:14px;margin-bottom:10px}
      .lcpp-complete-set__summary-label{color:#617181;font-size:12px;line-height:1.25}
      .lcpp-complete-set__total{color:#0b2339;font-size:21px;line-height:1;font-weight:900;letter-spacing:-.02em;white-space:nowrap}
      .lcpp-complete-set__cta{appearance:none;width:100%;min-height:50px;padding:0 18px;border:0;border-radius:12px;background:#0b2339;color:#fff;font:inherit;font-size:14px;font-weight:900;cursor:pointer;transition:background .15s ease,transform .15s ease,opacity .15s ease}
      .lcpp-complete-set__cta:hover{background:#153c5c}
      .lcpp-complete-set__cta:active{transform:translateY(1px)}
      .lcpp-complete-set__cta:disabled{cursor:not-allowed;opacity:.55}
      .lcpp-complete-set__status{min-height:18px;margin:8px 0 0;color:#617181;font-size:12px;line-height:1.35;text-align:center}
      .lcpp-complete-set__status.is-success{color:#176447;font-weight:750}
      .lcpp-complete-set__status.is-error{color:#9b2c2c;font-weight:750}
      .lcpp-complete-set__note{margin:8px 0 0;color:#7a8793;font-size:11px;line-height:1.4;text-align:center}
      @media (max-width:599px){
        .lcpp-complete-set{margin-top:14px;padding:14px;border-radius:15px}
        .lcpp-complete-set__title{font-size:17px}
        .lcpp-complete-set__item{grid-template-columns:auto 58px minmax(0,1fr);gap:9px;padding:10px}
        .lcpp-complete-set__check{width:22px;height:22px}
        .lcpp-complete-set__image-link{width:58px;height:58px}
        .lcpp-complete-set__name{font-size:13px}
        .lcpp-complete-set__meta{gap:5px}
        .lcpp-complete-set__variant{grid-column:2/-1;max-width:none;margin-top:7px;min-height:40px}
        .lcpp-complete-set__cta{min-height:52px}
        body.${BODY_IN_VIEW} .lcpp-mobilebar{display:none!important}
      }
    `;
    document.head.appendChild(style);
  };

  const fetchJson = async (url) => {
    const response = await fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.json();
  };

  const productKey = (product) => String(product?.id || product?.handle || '');

  const getImage = (product) => {
    if (typeof product?.featured_image === 'string') return product.featured_image;
    if (product?.featured_image?.src) return product.featured_image.src;
    if (Array.isArray(product?.images) && product.images[0]) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0]?.src || '';
    }
    return '';
  };

  const availableVariants = (product) =>
    Array.isArray(product?.variants)
      ? product.variants.filter((variant) => variant?.available && variant?.id)
      : [];

  const parseStructuredTags = (product) => {
    const map = {};
    const tags = Array.isArray(product?.tags)
      ? product.tags
      : typeof product?.tags === 'string'
        ? product.tags.split(',').map((tag) => tag.trim())
        : [];

    tags.forEach((rawTag) => {
      const tag = String(rawTag || '');
      if (!tag.startsWith('LCF__')) return;
      const parts = tag.split('__');
      if (parts.length < 3) return;
      const key = parts[1]?.trim();
      const value = parts.slice(2).join('__').trim();
      if (!key || !value) return;
      if (!map[key]) map[key] = [];
      if (!map[key].includes(value)) map[key].push(value);
    });
    return map;
  };

  const normalize = (value) => String(value || '').trim().toLowerCase();
  const isDefaultVariantTitle = (title) => ['default title', 'standaardtitel', 'standardtitel', 'titre par défaut'].includes(normalize(title));
  const intersects = (a = [], b = []) => {
    const right = new Set(b.map(normalize));
    return a.some((value) => right.has(normalize(value)));
  };

  const categoryKind = (product) => {
    const tags = parseStructuredTags(product);
    const categories = (tags.Categorie || []).map(normalize).join(' ');
    const type = normalize(product?.type || product?.product_type || '');
    const haystack = `${categories} ${type}`;
    if (haystack.includes('powerbank')) return 'powerbank';
    if (haystack.includes('hoesje')) return 'hoesje';
    if (haystack.includes('screenprotector') || haystack.includes('protector')) return 'protector';
    if (haystack.includes('kabel')) return 'kabel';
    if (haystack.includes('oplader') || haystack.includes('autolader')) return 'oplader';
    return '';
  };

  const targetFor = (product) => {
    const kind = categoryKind(product);
    if (kind === 'oplader' || kind === 'powerbank') return { kind: 'kabel', collection: 'oplaadkabel-telefoon' };
    if (kind === 'kabel') return { kind: 'oplader', collection: 'premium-opladers' };
    if (kind === 'hoesje') return { kind: 'protector', collection: 'protectors' };
    if (kind === 'protector') return { kind: 'hoesje', collection: 'hoesjes' };
    return null;
  };

  const isBundleLike = (product) => {
    const tags = Array.isArray(product?.tags) ? product.tags.map(normalize) : [];
    return normalize(product?.type).includes('bundel') || tags.some((tag) => tag.includes('categorie__bundel'));
  };

  const scoreCandidate = (current, candidate, explicit = false) => {
    if (!candidate || productKey(candidate) === productKey(current) || isBundleLike(candidate)) return -999;
    if (!availableVariants(candidate).length) return -999;
    if (explicit) return 1000;

    const target = targetFor(current);
    if (!target || categoryKind(candidate) !== target.kind) return -999;

    const currentTags = parseStructuredTags(current);
    const candidateTags = parseStructuredTags(candidate);
    let score = 60;

    const compatibilityA = currentTags.Compatibiliteit || [];
    const compatibilityB = candidateTags.Compatibiliteit || [];
    const portsA = currentTags.Aansluiting || [];
    const portsB = candidateTags.Aansluiting || [];

    if ((target.kind === 'protector' || target.kind === 'hoesje') && compatibilityA.length) {
      if (!compatibilityB.length || !intersects(compatibilityA, compatibilityB)) return -999;
      score += 45;
    } else if (compatibilityA.length && compatibilityB.length && intersects(compatibilityA, compatibilityB)) {
      score += 25;
    }

    if ((target.kind === 'kabel' || target.kind === 'oplader') && portsA.length && portsB.length) {
      if (!intersects(portsA, portsB)) return -999;
      score += 35;
    }

    const currentFunctions = currentTags.Functie || [];
    const candidateFunctions = candidateTags.Functie || [];
    if (intersects(currentFunctions, candidateFunctions)) score += 8;

    if (availableVariants(candidate).length === 1) score += 6;
    return score;
  };

  const dedupe = (products) => {
    const seen = new Set();
    return products.filter((product) => {
      const key = productKey(product);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const chooseProducts = async (current) => {
    const root = getRoot();
    const chosen = [];
    const chosenKeys = new Set([productKey(current)]);

    const take = (products, explicit = false) => {
      const ranked = dedupe(Array.isArray(products) ? products : [])
        .map((product) => ({ product, score: scoreCandidate(current, product, explicit) }))
        .filter(({ product, score }) => score > 0 && !chosenKeys.has(productKey(product)))
        .sort((a, b) => b.score - a.score);

      ranked.forEach(({ product }) => {
        if (chosen.length >= MAX_ITEMS) return;
        const key = productKey(product);
        if (chosenKeys.has(key)) return;
        chosen.push(product);
        chosenKeys.add(key);
      });
    };

    try {
      const complementary = await fetchJson(
        `${root}recommendations/products.json?product_id=${encodeURIComponent(current.id)}&limit=8&intent=complementary`
      );
      take(complementary?.products, true);
    } catch (_) {}

    if (chosen.length < MAX_ITEMS) {
      try {
        const related = await fetchJson(
          `${root}recommendations/products.json?product_id=${encodeURIComponent(current.id)}&limit=10&intent=related`
        );
        take(related?.products, false);
      } catch (_) {}
    }

    if (chosen.length < MAX_ITEMS) {
      const target = targetFor(current);
      if (target?.collection) {
        try {
          const fallback = await fetchJson(`${root}collections/${encodeURIComponent(target.collection)}/products.json?limit=50`);
          take(fallback?.products, false);
        } catch (_) {}
      }
    }

    return chosen.slice(0, MAX_ITEMS);
  };

  const selectedMainVariant = (form, current) => {
    const input = form.querySelector('[name="id"]');
    const id = String(input?.value || '');
    const variants = Array.isArray(current?.variants) ? current.variants : [];
    return variants.find((variant) => String(variant.id) === id) || variants.find((variant) => variant.available) || variants[0] || null;
  };

  const render = (current, products) => {
    const pageRoot = document.querySelector('[data-lcpp-root]');
    let labels = {};
    try { labels = JSON.parse(pageRoot?.querySelector('[data-lcpp-labels]')?.textContent || '{}'); } catch (_) { labels = {}; }
    const info = pageRoot?.querySelector('.lcpp-info') || document.querySelector('.lcpp-info');
    const form = info?.querySelector('form.lcpp-form, .lcpp-form');
    if (!info || !form || info.querySelector('.lcpp-complete-set') || !products.length) return;

    const section = document.createElement('section');
    section.className = 'lcpp-complete-set';
    section.setAttribute('aria-labelledby', 'lcpp-complete-set-title');

    const head = document.createElement('div');
    head.className = 'lcpp-complete-set__head';
    const headingWrap = document.createElement('div');
    const eyebrow = document.createElement('p');
    eyebrow.className = 'lcpp-complete-set__eyebrow';
    eyebrow.textContent = labels.completeEyebrow || 'Passende extra’s';
    const title = document.createElement('h3');
    title.id = 'lcpp-complete-set-title';
    title.className = 'lcpp-complete-set__title';
    title.textContent = labels.completeTitle || 'Maak je bestelling compleet';
    const subtitle = document.createElement('p');
    subtitle.className = 'lcpp-complete-set__subtitle';
    subtitle.textContent = labels.completeSubtitle || 'Kies een aanvulling en voeg alles in één keer toe.';
    headingWrap.append(eyebrow, title, subtitle);
    head.appendChild(headingWrap);

    const itemsWrap = document.createElement('div');
    itemsWrap.className = 'lcpp-complete-set__items';
    const selections = [];

    products.forEach((product, index) => {
      const variants = availableVariants(product);
      if (!variants.length) return;

      const item = document.createElement('article');
      item.className = 'lcpp-complete-set__item';

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.checked = true;
      checkbox.className = 'lcpp-complete-set__check';
      checkbox.setAttribute('aria-label', `${labels.selectPrefix || 'Selecteer'} ${product.title || labels.supplementalProduct || 'aanvullend product'}`);

      const imageLink = document.createElement('a');
      imageLink.className = 'lcpp-complete-set__image-link';
      imageLink.href = product.url || `${getRoot()}products/${product.handle || ''}`;
      const imageUrl = getImage(product);
      if (imageUrl) {
        const image = document.createElement('img');
        image.className = 'lcpp-complete-set__image';
        image.src = imageUrl;
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.width = 144;
        image.height = 144;
        imageLink.appendChild(image);
      }

      const infoWrap = document.createElement('div');
      infoWrap.className = 'lcpp-complete-set__info';
      const name = document.createElement('a');
      name.className = 'lcpp-complete-set__name';
      name.href = product.url || `${getRoot()}products/${product.handle || ''}`;
      name.textContent = product.title || labels.supplementalProductCap || 'Aanvullend product';

      const meta = document.createElement('div');
      meta.className = 'lcpp-complete-set__meta';
      const price = document.createElement('span');
      price.className = 'lcpp-complete-set__price';
      const stock = document.createElement('span');
      stock.className = 'lcpp-complete-set__stock';
      stock.textContent = labels.orderable || 'Bestelbaar';
      meta.append(price, stock);
      infoWrap.append(name, meta);

      let variantSelect = null;
      if (variants.length > 1 || (variants[0]?.title && !isDefaultVariantTitle(variants[0].title))) {
        variantSelect = document.createElement('select');
        variantSelect.className = 'lcpp-complete-set__variant';
        variantSelect.setAttribute('aria-label', `${labels.chooseVariantPrefix || 'Kies variant van'} ${product.title || labels.supplementalProduct || 'aanvullend product'}`);
        variants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title && !isDefaultVariantTitle(variant.title)
            ? `${variant.title} — ${formatMoney(variant.price)}`
            : formatMoney(variant.price);
          variantSelect.appendChild(option);
        });
        infoWrap.appendChild(variantSelect);
      }

      const selection = {
        product,
        checkbox,
        variantSelect,
        price,
        getVariant() {
          const selectedId = variantSelect?.value;
          return variants.find((variant) => String(variant.id) === String(selectedId)) || variants[0];
        }
      };
      selections.push(selection);

      item.append(checkbox, imageLink, infoWrap);
      itemsWrap.appendChild(item);
    });

    if (!selections.length) return;

    const foot = document.createElement('div');
    foot.className = 'lcpp-complete-set__foot';
    const summary = document.createElement('div');
    summary.className = 'lcpp-complete-set__summary';
    const summaryLabel = document.createElement('div');
    summaryLabel.className = 'lcpp-complete-set__summary-label';
    summaryLabel.textContent = labels.totalSelected || 'Totaal geselecteerd';
    const total = document.createElement('div');
    total.className = 'lcpp-complete-set__total';
    summary.append(summaryLabel, total);

    const cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'lcpp-complete-set__cta';
    cta.textContent = labels.addTogether || 'Voeg samen toe';

    const status = document.createElement('p');
    status.className = 'lcpp-complete-set__status';
    status.setAttribute('aria-live', 'polite');

    const note = document.createElement('p');
    note.className = 'lcpp-complete-set__note';
    note.textContent = labels.noDiscount || 'Geen extra korting toegepast; je betaalt de actuele productprijzen.';

    foot.append(summary, cta, status, note);
    section.append(head, itemsWrap, foot);
    form.insertAdjacentElement('afterend', section);

    const update = () => {
      const mainVariant = selectedMainVariant(form, current);
      const quantityInput = form.querySelector('[name="quantity"]');
      const mainQuantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
      let cents = toCents(mainVariant?.price) * mainQuantity;
      let extraCount = 0;

      selections.forEach((selection) => {
        const variant = selection.getVariant();
        selection.price.textContent = formatMoney(variant?.price || 0);
        if (selection.checkbox.checked && variant?.available) {
          cents += toCents(variant.price);
          extraCount += 1;
        }
      });

      total.textContent = formatMoney(cents);
      cta.disabled = !mainVariant?.available || extraCount === 0;
      cta.textContent = extraCount > 0
        ? `${labels.addTogether || 'Voeg samen toe'}${extraCount > 1 ? ` (${extraCount + 1} ${labels.products || 'producten'})` : ''}`
        : (labels.selectAddition || 'Selecteer een aanvulling');
    };

    selections.forEach((selection) => {
      selection.checkbox.addEventListener('change', update);
      selection.variantSelect?.addEventListener('change', update);
    });
    form.querySelector('[name="id"]')?.addEventListener('change', update);
    form.querySelector('[name="quantity"]')?.addEventListener('change', update);
    form.querySelector('[name="quantity"]')?.addEventListener('input', update);

    const priceNode = info.querySelector('[data-lcpp-price]');
    if (priceNode) new MutationObserver(update).observe(priceNode, { childList: true, subtree: true, characterData: true });

    cta.addEventListener('click', async () => {
      if (cta.disabled) return;
      const mainVariant = selectedMainVariant(form, current);
      const quantityInput = form.querySelector('[name="quantity"]');
      const mainQuantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
      const extras = selections
        .filter((selection) => selection.checkbox.checked)
        .map((selection) => selection.getVariant())
        .filter((variant) => variant?.available && variant?.id);

      if (!mainVariant?.available || !extras.length) return;

      const items = [
        { id: Number(mainVariant.id), quantity: mainQuantity },
        ...extras.map((variant) => ({ id: Number(variant.id), quantity: 1 }))
      ];

      cta.disabled = true;
      cta.textContent = labels.adding || 'Toevoegen…';
      status.className = 'lcpp-complete-set__status';
      status.textContent = '';

      try {
        const response = await fetch(`${getRoot()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart add failed');
        const result = await response.json();
        status.className = 'lcpp-complete-set__status is-success';
        status.textContent = labels.setAdded || 'Complete set toegevoegd ✓';
        cta.textContent = labels.added || 'Toegevoegd ✓';
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          window.location.assign(`${getRoot()}cart`);
        }, 450);
      } catch (_) {
        status.className = 'lcpp-complete-set__status is-error';
        status.textContent = labels.addError || 'Toevoegen is niet gelukt. Controleer de gekozen varianten en probeer opnieuw.';
        cta.disabled = false;
        update();
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const inView = entries.some((entry) => entry.isIntersecting);
        document.body.classList.toggle(BODY_IN_VIEW, inView);
      }, { threshold: 0.08 });
      observer.observe(section);
    }

    update();
  };

  const init = async () => {
    const handle = getHandle();
    if (!handle) return;
    addStyles();

    try {
      const current = await fetchJson(`${getRoot()}products/${encodeURIComponent(handle)}.js`);
      if (!current?.id || !Array.isArray(current?.variants)) return;
      const products = await chooseProducts(current);
      if (!products.length) return;
      render(current, products);
    } catch (_) {
      // If recommendation data is unavailable, leave the regular product form untouched.
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
